import React from 'react';

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // Layout now just renders children - the DashboardHeader is included in each dashboard page
  return (
    <div className="min-h-screen bg-gray-50">
      {children}
    </div>
  );
};

export default Layout;
